import { render, staticRenderFns } from "./summary-of-portfolio-at-risk.vue?vue&type=template&id=486a312f&"
import script from "./summary-of-portfolio-at-risk.vue?vue&type=script&lang=js&"
export * from "./summary-of-portfolio-at-risk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports